var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeposit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.862,
    height: 17.625,
    viewBox: "0 0 15.862 17.625",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "receive",
    transform: "translate(0 0)",
    opacity: 0.301
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8254",
    "data-name": "Path 8254",
    d: "M15.922,130.644H14.6v-2.2a.441.441,0,0,0-.441-.441H12.4a.441.441,0,0,0,0,.881h1.322v1.762H2.262a.881.881,0,1,1,0-1.762h2.2a.441.441,0,1,0,0-.881h-2.2A1.764,1.764,0,0,0,.5,129.762v9.694a1.764,1.764,0,0,0,1.762,1.762H15.922a.441.441,0,0,0,.441-.441v-9.694A.441.441,0,0,0,15.922,130.644ZM2.262,140.337a.882.882,0,0,1-.881-.881V131.28a1.743,1.743,0,0,0,.881.245H15.481v2.644H12.4a.441.441,0,0,0-.441.441v2.644a.441.441,0,0,0,.441.441h3.084v2.644Zm13.218-3.525H12.837V135.05h2.644Zm0,0",
    transform: "translate(-0.5 -123.594)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8255",
    "data-name": "Path 8255",
    d: "M156.464,6.072a.442.442,0,0,0,.551,0l2.2-1.762a.441.441,0,0,0-.551-.688l-1.487,1.19V.441a.441.441,0,1,0-.881,0V4.811l-1.487-1.19a.441.441,0,1,0-.551.688Zm0,0",
    transform: "translate(-148.809 0)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.11e96476678e8845a9c32812e73dc44e.svg";
export { ForwardRef as ReactComponent };